import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageDescription: {
		id: 'servicedesk.automation.summary.page-description',

		defaultMessage:
			'Automation rules do repetitive tasks for you. Edit a pre-configured rule or build your own.',

		description: '',
	},
});
